import * as React from "react";
import { useIntl } from "react-intl";

function useFormatter() {
  const { formatNumber, formatMessage } = useIntl();

  const electricity_unit = React.useMemo(
    () => formatMessage({ id: "units.amper" }),
    [formatMessage]
  );

  const formatCurrency = React.useCallback(
    (value: number | undefined) => {
      return value
        ? formatNumber(value, {
            style: "currency",
            currency: "$",
          })
        : "--";
    },
    [formatNumber]
  );

  const formatElectricity = React.useCallback(
    (value: number | undefined) => {
      if (value == null) return `--${electricity_unit}`;
      return `${value}${electricity_unit}`;
    },
    [electricity_unit]
  );

  return {
    electricity_unit,
    formatCurrency,
    formatElectricity,
  };
}

export default useFormatter;
